<template>
	<div :class="['sidenav-container', {'dark-blue-mode' : $route.meta.headerColor === 'dark'}]" id="sideMenu">
		<TransitionGroup
			v-if="!$route.path.includes('/gop/')"
			:name="$store.getters.getSideMenuField('currentSlide') === slideSteps.first ? 'slideInverce' : 'slide'"
		>
			<SlideFirst key="one" v-if="$store.getters.getSideMenuField('currentSlide') === slideSteps.first"/>
		</TransitionGroup>
		<GopSideMenu v-else />
	</div>
</template>
<script>
import SlideFirst from "@/common/components/sideMenu/SlideFirst";
import GopSideMenu from "@/common/components/sideMenu/GopSideMenu";
import slideMenuMixin from "@/common/mixins/slide-menu-mixin";
import {EventSideMenu} from "@/common/configurations/event-bus.js";

export default {
	name: "SideMenu",
	mixins: [slideMenuMixin],
	components: {
		SlideFirst,
		GopSideMenu
	},
	mounted() {
		this.displayResize();
	},
	methods: {
		toggleSideMenu() {
			document.getElementById('sideMenu').classList.toggle('active')
      this.closeAllOpenedHovers();
		},
		closeSideMenu() {
			document.getElementById('sideMenu').classList.remove('active')
      this.closeAllOpenedHovers();
		},
		displayResize() {
			this.currentDisplayWidth = window.innerWidth
			this.adjustSideMenuOverflow();
		},
		adjustSideMenuOverflow() {
			if (this.currentDisplayWidth >= this.tabletDisplayPx) {
				document.getElementById('sideMenu').style.overflow = "visible";
			} else {
				document.getElementById('sideMenu').style.overflowY = "scroll";
			}
		}
	},
	created() {
		EventSideMenu.$on('toggle-sidemenu', this.toggleSideMenu);
		EventSideMenu.$on('close-sidemenu', this.closeSideMenu);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayResize);
		})
	},
	destroyed() {
		window.removeEventListener('resize', this.displayResize);
		EventSideMenu.$off('toggle-sidemenu', this.toggleSideMenu);
		EventSideMenu.$off('close-sidemenu', this.closeSideMenu);
	}
}
</script>
<style lang="sass">
.dark-blue-mode
	background: #001F33

.slide-leave-active, .slide-enter-active,
.slideInverce-leave-active, .slideInverce-enter-active
	transition: .6s

.slide-enter
	transform: translate(200%, 0)

.slide-leave-to
	transform: translate(-200%, 0)

.slideInverce-enter
	transform: translate(-200%, 0)

.slideInverce-leave-to
	transform: translate(200%, 0)

.sidenav-container
	width: 300px
	height: calc(100vh - 65px)
	background: #fff
	display: flex
	flex-direction: column
	justify-content: space-between
	transition: all .3s ease-in-out
	margin-left: -300px
	position: absolute
	z-index: 101
	border-radius: 0 !important
	scrollbar-width: thin

	&.active
		margin-left: 0

	&::-webkit-scrollbar
		width: 5px
		padding: 0 2px

	&::-webkit-scrollbar-track
		background: transparent
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2)

	&::-webkit-scrollbar-thumb
		background: #FDB71A
		-webkit-border-radius: 10px
		border-radius: 10px

	&::-webkit-scrollbar-thumb:hover
		background: #555

	@media (max-width: 425px)
		margin-left: -100%
		width: calc(100% - 50px)

	@media (max-width: 330px)
		width: 100%

</style>
